import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlignBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.25 15.25h-2.5a2 2 0 0 1-2-2v-6.5a2 2 0 0 1 2-2h2.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2M4.75 19.25h14.5"
    />
  </svg>
);
export default SvgAlignBottom;
